// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"341ce564","476":"1c4d3f16","763":"0409d04d"}[chunkId] + ".chunk.js";
};